import { Button, CircularProgress, Dialog, DialogContent } from "@mui/material";
import { makeStyles } from "@mui/styles";
import * as React from "react";

import warning from "../../../../../../assets/health/warning.svg";
import success from "../../../../../../assets/health/success.svg";

export default function DialogConfirm(props) {
  const { dispatch, state } = props;
  const classes = makeStyle();
  const { dialogAddOriginalDoc } = state;

  return (
    <Dialog
      open={dialogAddOriginalDoc?.openConfirm }
      keepMounted
      className={classes.dialog}
    >
      <DialogContent style={{ padding: 20, textAlign: "center" }}>
        {dialogAddOriginalDoc?.type === "success" ? (
          <>
            <img
              src={success}
              alt="success"
              style={{ width: "100%", maxWidth: "60px" }}
            />
            <div className="text">Gửi Thành Công</div>
          </>
        ) : (
          <>
            <img
              src={warning}
              alt="warning"
              style={{ width: "100%", maxWidth: "60px" }}
            />
            <div className="text">
              Bạn có chắc chắn muốn gửi thông tin bổ sung chứng từ
            </div>
            <div className="footer">
              <Button
                className="btn-back"
                disabled={!!dialogAddOriginalDoc?.loading}
                onClick={() =>
                  dispatch({
                    type: "onChangeMdAddOriginalDoc",
                    name: "openConfirm",
                    value: false,
                  })
                }
              >
                Quay lại
              </Button>
              <Button
                className="btn-next"
                disabled={!!dialogAddOriginalDoc?.loading}
                onClick={() => dispatch("addOriginalDoc")}
              >
                {dialogAddOriginalDoc?.loading && (
                  <CircularProgress
                    color="inherit"
                    size={"18px"}
                    style={{ marginRight: 8 }}
                  />
                )}
                Đồng ý
              </Button>
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}

const makeStyle = makeStyles(() => ({
  dialog: {
    "& .MuiPaper-root.MuiPaper-elevation": {
      borderRadius: "12px",
      width: "100%",
      maxWidth: "350px",
      margin: 0,
    },

    "& .text": {
      marginTop: 10,
      fontWeight: 500,
    },

    "& .footer": {
      margin: "10px 0px",
      display: "flex",
      justifyContent: "center",
    },

    "& .btn-back": {
      textTransform: "none",
      background: "#F0F2F5",
      color: "#343A40",
      borderRadius: "8px",
      padding: "8px 24px",
    },

    "& .btn-next": {
      textTransform: "none",
      background: "#3961A0",
      color: "white",
      borderRadius: "8px",
      padding: "8px 24px",
      marginLeft: 20,
    },
    
    "& .Mui-disabled": {
      opacity: 0.3,
    },
  },
}));
